import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  ResponsiveValue,
} from "@chakra-ui/react";
import React, { forwardRef, ReactNode } from "react";

const CommonDrawer = forwardRef(function CommonDrawer({
  title,
  isOpen,
  size,
  placement = "left",
  onClose,
  btnRef,
  variant,
  children,
}: {
  title: string;
  isOpen: boolean;
  placement?: "left" | "right" | "bottom" | "top";
  size?:
    | ResponsiveValue<
        | (string & {})
        | "xs"
        | "sm"
        | "md"
        | "lg"
        | "xl"
        | "2xl"
        | "3xl"
        | "4xl"
        | "full"
      >
    | undefined;
  onClose: () => void;
  btnRef?: React.MutableRefObject<any>;
  variant?: string;
  children: ReactNode;
}) {
  return (
    <Drawer
      isOpen={isOpen}
      placement={placement}
      onClose={onClose}
      finalFocusRef={btnRef?.current}
      size={size ?? "lg"}
      variant={variant ?? "primary"}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>{title}</DrawerHeader>
        <DrawerBody>{children}</DrawerBody>
      </DrawerContent>
    </Drawer>
  );
});

const MemoizedCommonDrawer = React.memo(CommonDrawer);
export default MemoizedCommonDrawer;
